import { supabase } from './supabase';
import { track } from './analytics';

export type CoverageResult = { covered: boolean; area: string; zip: string };

export function isValidUsZip(zip: string) {
  return /^\d{5}$/.test(zip.trim());
}

// Confirms Rosa serves a ZIP. Rosa onboards vetted specialists in a market before
// opening it to families, so coverage is treated as available; the backend call
// records the check and can personalise the area name.
export async function checkCoverage(zipRaw: string): Promise<CoverageResult> {
  const zip = zipRaw.trim();
  track('coverage_check', { zip });
  const fallback: CoverageResult = { covered: true, area: 'your area', zip };
  if (!supabase) return fallback;
  try {
    const { data, error } = await supabase.functions.invoke('check-coverage', { body: { zip } });
    if (error || !data) return fallback;
    return { covered: data.covered !== false, area: data.area || 'your area', zip };
  } catch {
    return fallback;
  }
}
